import React, { useState, useEffect, useContext } from "react";
import HaqtChart from "../../components/HaqtCharts/HaqtChart";
import { AppContext } from "../../context/AppContextProvider";
import Box from "@mui/material/Box";
import { getParameterLogs } from "../../services/DashboardServices";
import { getSessionStorageItem } from "../../utils/sessionStorageUtils.js";
import testData from "./data";
import { Link } from "react-router-dom";
import { timestampToDateTime } from "../../utils/TimeStampToDateTime.js";
import { convertToLocalDate } from "../../utils/FormatDate.js";
import { truncateDecimals } from "../../utils/TruncateDecimals.js";

const DashboardCharts = (props) => {
  const { setShowSpinner } = useContext(AppContext);
  const [dashboardChartData, setDashboardChartData] = useState({});

  const selectedSystemData = getSessionStorageItem("haqt-selected-system");
  //const systemId = selectedSystemData?.system?.id;
  

  const systemId = '08db1883-88f1-4bfa-8c8e-5c68d64fa2be';

//const systemId ='08dc9f58-f1bd-4470-8e73-14054022c237';
// Output the systemId if needed
console.log("Selected systemId IN DAHSBOARD CHART:", systemId);
  const loadDashboardCharts = async () => {
    try {
      setShowSpinner(true);
      console.log("Iam at dbchart page")
      const chartData = await dashboardChartApi(props.card.parameterId, systemId);
      setDashboardChartData(chartData);
      setShowSpinner(false);

      // setTimeout(() => {
      //   console.log(testData["/getParameterLogs/:parameterId"].response);
      //   setDashboardChartData(testData["/getParameterLogs/:parameterId"].response);
      //   setShowSpinner(false);
      // }, 1000);
    } catch (e) {
      setShowSpinner(false);
      console.log(e);
    }
  };

  useEffect(() => {
    if (!props.tile) {
      loadDashboardCharts();
    }
  }, []);

  const dashboardChartApi = async (parameterId, systemId) => {
    try {
      const response = await getParameterLogs(parameterId, systemId);
      return (response && response.data ? response.data : null);
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  const dashboardDetailOption = {
    chart: {
      height: 450,
      zoomType: 'x'
    },
    title: {
      text: 'Parameter Logs',
      align: 'center'
    },
    subtitle: {
      text:
        document.ontouchstart === undefined
          ? 'Click and drag in the plot area to zoom in'
          : 'Pinch the chart to zoom in',
      align: 'center'
    },
    xAxis: { type: "datetime" },
    yAxis: {
      title: "Values",
    },
    legend: {
      enabled: true,
      layout: "vertical",
      title: "Property",
      align: "center",
      verticalAlign: "bottom",
    },
    tooltip: {
      borderColor: "#fff",
      // borderRadius: 3,
      borderWidth: 1,
      className: "dashboard-chart-tooltip",
      formatter: function () {
        return tooltipContent(this.x, this.y, this.point.series.options);
      },
    },
    exporting:{fileName:`Dashboard_${props?.card?.tileName || props?.tile?.tileName}`}
  };
  

  const tooltipContent = (x, y, value) => {
    return `
      <Box className="tooltip-content">
      <Typography>${timestampToDateTime(x)}</Typography><br/><br/>
      <Typography>Min: ${truncateDecimals(value.minValue)}</Typography><br/><br/>
      <Typography>Curr: ${truncateDecimals(y)}</Typography><br/><br/>
      <Typography>Max: ${truncateDecimals(value.maxValue)}</Typography>
      </Box>
    `;
  };

  return (
    <Box className="dashboard-chart-container">
      <Link style={{ color: '#005572', textDecoration: 'none', fontWeight: 'bold' }} to={"/admin/chartinsights"}>{"Go to Charts >"}</Link>
      {props.tile ? (
        <HaqtChart
          options={dashboardDetailOption}
          series={props.tile.parameters.map((parameter) => {
            return {
              type: props.tile?.tilePreference?.toLowerCase() || "line",
              name: `${parameter.parameterName} ${parameter.uom && parameter.uom.trim() !==''  ? `[${parameter.uom}]` : ''}`,
              minValue: parameter.minValue,
              maxValue: parameter.maxValue,
              data: parameter.totalValues
              .sort((a, b) => new Date(a.logDateTime) - new Date(b.logDateTime)) // Sort the data by logDateTime
              .map((item) => {
                return [new Date(convertToLocalDate(item.logDateTime)).getTime(), parseFloat(item.value)];
              })
            };
          })}
        />) : ((dashboardChartData && dashboardChartData.history) &&
          <HaqtChart
            options={dashboardDetailOption}
            series={[{
              type: "line",
              name: `${props?.card?.parameterName} ${props?.card?.uom && props?.card?.uom.trim() !=='' ? `[${props?.card?.uom}]` : ''}`,
              minValue: props?.card?.minValue,
              maxValue: props?.card?.maxValue,
              data: dashboardChartData.totalValues
              .sort((a, b) => new Date(a.logDateTime) - new Date(b.logDateTime)) // Sort the data by logDateTime
              .map((item) => {
                return [new Date(convertToLocalDate(item.logDateTime)).getTime(), parseFloat(item.value)];
              })
            }]}
          />
      )}
    </Box>
  );
};

export default DashboardCharts;
